/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HiOutlineRefresh } from "react-icons/hi";
import {
  selectRetrofitConfiguration,
  selectCurrentAxisId,
  selectFiltersPopupOpened,
  setAxisFilters,
  setFiltersPopupOpened
} from "../../../store/slices/retrofit";
import t from "../../../utils/common/translation/translator";
import DriveFilters from "../../../components/Retrofit/Devices/Filters/DriveFilters";
import CustomPopup from "../../../components/common/CustomPopup/CustomPopup";

const FiltersPopup = () => {
  const filtersPopupOpened = useSelector(selectFiltersPopupOpened);
  const dispatch = useDispatch();

  const [initialDriveFilters, setInitialDriveFilters] = useState(null);
  const [driveFilters, setDriveFilters] = useState(null);

  const axisId = useSelector(selectCurrentAxisId);
  const configuration = useSelector(selectRetrofitConfiguration);

  const axisName = configuration?.configData.axes.find((a) => a.id === axisId)?.name;

  useEffect(() => {
    // save the initial filters when opening the popup
    const axisFromConfiguration = configuration?.configData.axes.find((a) => a.id === axisId);
    setInitialDriveFilters(axisFromConfiguration?.configFilters?.driveFilter);
  }, [filtersPopupOpened]);

  useEffect(() => {
    // get the new drive filters from the configuration
    const axisFromConfiguration = configuration?.configData.axes.find((a) => a.id === axisId);
    setDriveFilters(axisFromConfiguration.configFilters?.driveFilter);
  }, [filtersPopupOpened, configuration]);

  const handleCancelChanges = () => {
    // reset the filters to the initial state
    const filters = {
      ...configuration.configData.axes.find((a) => a.id === axisId).configFilters,
      driveFilter: initialDriveFilters
    };

    dispatch(setAxisFilters({ axisId, filters }));
  };

  const [isClearing, setIsClearing] = useState(false);
  const [shouldRerender, setShouldRerender] = useState(true);

  const handleClearFilters = () => {
    setIsClearing(true);
    setTimeout(() => {
      setIsClearing(false);
    }, 500);

    const filters = {
      ...configuration.configData.axes.find((a) => a.id === axisId).configFilters,
      driveFilter: {
        nbPhases: [],
        driveVoltages: [],
        driveInterface: []
      }
    };

    dispatch(setAxisFilters({ axisId, filters }));
    setShouldRerender(!shouldRerender);
  };

  return (
    <CustomPopup
      headerTitle={`${t("msizer.ui.popup.edit_application_settings.title")} - ${axisName}`}
      opened={filtersPopupOpened}
      onClose={() => {
        handleCancelChanges();
        dispatch(setFiltersPopupOpened(false));
      }}
      cancelAction={() => {
        // console.log("cancel");
        handleCancelChanges();
        dispatch(setFiltersPopupOpened(false));
      }}
      continueLabel={t("msizer.ui.popup.button.apply")}
      cancelLabel={t("msizer.ui.popup.button.cancel")}
      continueAction={() => {
        // console.log("continue");
        dispatch(setFiltersPopupOpened(false));
      }}
      // disabled if nbPhases, driveVoltages or driveInterface are empty
      continueDisabled={
        driveFilters?.nbPhases?.length === 0 ||
        driveFilters?.driveVoltages?.length === 0 ||
        driveFilters?.driveInterface?.length === 0
      }
      closeOnDocumentClick={false}
    >
      <div>
        <div className="p-2 pt-0 space-y-5 text-sm">
          <div
            className="flex-1 flex items-center justify-end text-sm text-secondary
"
          >
            <div
              onClick={() => {
                handleClearFilters();
              }}
              className="flex items-center space-x-1 cursor-pointer"
            >
              <HiOutlineRefresh className={isClearing && "animate-spin"} />
              <span>{t("msizer.ui.filters.reset_filters")}</span>
            </div>
          </div>
          <DriveFilters filterToDisplay="applicationSettings" shouldRerender={shouldRerender} />
        </div>
      </div>
    </CustomPopup>
  );
};

export default FiltersPopup;
